<template>

<div class="row">
    <div class="col-12 text-center">
        <div class="breadcrumbs">
            <a :href="url()" class=''>Начало</a> 
            
            <span v-for='(l,i) in $store.state.bcLinks'>
                <span class="separator">/</span>                
                <a :key='l.name' :href='i+1 == $store.state.bcLinks.length ? "" : url(l.url)' 
                    class='bc-item'>
                    {{ l.name }}
                </a>
            </span>
        </div>
    </div>
</div>

</template>

<script>
    export default {
        mounted() {

        },

    }
</script>
<style>

/*.bc-item {
    margin-right: 10px;
    padding: 5px;
    border: 1px solid;
    background-color:  white;
}
*/
</style>